import './bootstrap';
import { createInertiaApp, router } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import PrelineScript from './PrelineScript';


createInertiaApp({
    resolve: name => {
        const pages = import.meta.glob('./Pages/**/*.jsx', { eager: true })
        return pages[`./Pages/${name}.jsx`]
    },
    setup({ el, App, props }) {
        const applyTheme = (componentName) => {
            const isWebPage = componentName?.startsWith('Web/');
            const isPanelPage = !isWebPage;
            document.documentElement.classList.toggle('web-theme-neon', Boolean(isWebPage));
            document.documentElement.classList.toggle('panel-theme-neon', Boolean(isPanelPage));
        };

        applyTheme(props?.initialPage?.component);
        router.on('navigate', (event) => {
            applyTheme(event?.detail?.page?.component);
        });

        const Root = () => (
            <>
                <App {...props} />
                <PrelineScript />
            </>
        );

        createRoot(el).render(<Root />);
    },
})
